import React from "react";
import { Provider } from "react-redux";
import { cls } from "cls";
import ActiveFlashDeal from "./FlashDeals/ActiveFlashDeal";
import Store from "~/common/Store";
import ActiveFlashDealContainer from "./FlashDeals/ActiveFlashDealContainer";
import { FlashDealItem } from "../Models/PageCreatorPage";
import UpcomingDealItem from "./FlashDeals/UpcomingDealItem";
import FlashDealCarousel from "./FlashDeals/FlashDealCarousel";
import FlashDealCounter from "./FlashDeals/FlashDealCounter";

interface Props {
  couponCode: string;
  backgroundColor: string;
  textColor?: string;
  headerTextColor: string;
  activeFlashDeal: FlashDealItem | undefined;
  comingSoonDeals: FlashDealItem[];
  countdownDisplay: string;
}

const FlashDealItems = ({
  couponCode,
  backgroundColor,
  headerTextColor,
  activeFlashDeal,
  comingSoonDeals,
  countdownDisplay,
}: Props): JSX.Element => {
  return (
    <Provider store={Store}>
      <div
        className={`${cls(
          "flex",
          "flex-col",
          "md:flex-row",
          "gap-4",
          "w-auto",
          "md:gap-2",
          "md:w-full",
        )} ${
          comingSoonDeals.length > 0
            ? "lg:w-[calc(100%-296px)]"
            : "lg:w-[calc(100%-256px)]"
        }`}
      >
        {activeFlashDeal && (
          <ActiveFlashDealContainer
            backgroundColor={backgroundColor}
            hasUpcomingDeal={comingSoonDeals?.length > 0}
            header={
              <div className={cls("flex", "justify-between")}>
                <p
                  className={cls("font-semibold", "m-0", "text-base")}
                  style={{ color: headerTextColor }}
                >
                  Current Flash Deal
                </p>
                <FlashDealCounter
                  countdownDisplay={countdownDisplay}
                  start={false}
                />
              </div>
            }
          >
            <ActiveFlashDeal
              product={activeFlashDeal.product}
              salePrice={activeFlashDeal.salePrice}
              couponCode={couponCode}
              countdownDisplay={countdownDisplay}
              hasUpcomingDeal={comingSoonDeals?.length > 0}
            />
          </ActiveFlashDealContainer>
        )}
        {comingSoonDeals?.length > 0 && (
          <ActiveFlashDealContainer
            backgroundColor={backgroundColor}
            hasUpcomingDeal={comingSoonDeals?.length > 0}
            isUpcomingDeal
            header={
              <div className={cls("flex", "justify-between")}>
                <p
                  className={cls("font-semibold", "m-0", "text-base")}
                  style={{ color: headerTextColor }}
                >
                  Upcoming Deals
                </p>
              </div>
            }
          >
            <FlashDealCarousel colorVariant="pink">
              {comingSoonDeals.map((deal) => (
                <div
                  className="flash-deals-carousel__item"
                  key={deal.endDateTimeUtc}
                >
                  <UpcomingDealItem
                    product={deal.product}
                    salePrice={deal.salePrice}
                    startDateTime={deal.startDateTimeUtc}
                  />
                </div>
              ))}
            </FlashDealCarousel>
          </ActiveFlashDealContainer>
        )}
      </div>
    </Provider>
  );
};

export default FlashDealItems;
